(() => {
  // app/scripts/image-slide.js
  if (customElements.get("slide-image-cus")) return;
  let instanceCount = 0;
  // Outlined circle icons drawn to match the prev/next arrow buttons.
  const RING = '<circle cx="16" cy="16" r="14" fill="none" stroke="currentColor" stroke-width="2"/>';
  const PAUSE_ICON = `<svg aria-hidden="true" focusable="false" viewBox="0 0 32 32" width="32" height="32">${RING}<rect x="11.5" y="10" width="3" height="12" rx="1" fill="currentColor"/><rect x="17.5" y="10" width="3" height="12" rx="1" fill="currentColor"/></svg>`;
  const PLAY_ICON = `<svg aria-hidden="true" focusable="false" viewBox="0 0 32 32" width="32" height="32">${RING}<path d="M13 10.8v10.4a1 1 0 0 0 1.52.85l8.3-5.2a1 1 0 0 0 0-1.7l-8.3-5.2A1 1 0 0 0 13 10.8z" fill="currentColor"/></svg>`;
  customElements.define("slide-image-cus", class extends HTMLElement {
    connectedCallback() {
      var _this$motionQuery2, _this$arrowsObserver, _this$motionQuery3;
      if (this.connected) return;
      this.connected = true;
      if (!this.initialized) {
        var _window$matchMedia, _window, _this$motionQuery;
        this.initialized = true;
        this.slideImage = this.querySelector(".content-image swiper-component");
        this.slideContent = this.querySelector(".content-text swiper-component");
        this.listBlock = Array.from(this.querySelectorAll(".content-text swiper-component .block__item"));
        this.indexActive = 0;
        this.elapsed = 0;
        this.duration = 5000;
        this.playInterval = null;
        this.hoverPaused = false;
        this.motionQuery = (_window$matchMedia = (_window = window).matchMedia) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.call(_window, "(prefers-reduced-motion: reduce)");
        this.userPaused = Boolean((_this$motionQuery = this.motionQuery) === null || _this$motionQuery === void 0 ? void 0 : _this$motionQuery.matches);
        this.makeControls();
        this.onClick = this.handleClick.bind(this);
        this.onClickCapture = event => {
          const control = event.target.closest(".content-text .slider-controls button:not(.image-rotation-toggle)");
          this.arrowFocusIntent = control && this.contains(control) && document.activeElement === control ? control : null;
        };
        this.onPointerDown = event => {
          this.rotationPointerIntent = event.button === 0 && event.target.closest(".image-rotation-toggle") === this.rotationButton ? !this.userPaused : null;
        };
        this.onPointerCancel = () => {
          this.rotationPointerIntent = null;
        };
        this.onFocus = () => this.pause();
        this.onEnter = () => {
          this.hoverPaused = true;
          this.updateTimer();
        };
        this.onLeave = () => {
          this.hoverPaused = false;
          this.updateTimer();
        };
        this.onVisibility = () => this.updateTimer();
        this.onMotion = event => {
          if (event.matches) this.pause();
        };
        this.sliderBindings = new Map();
        this.onSwiperLayout = () => this.scheduleSlideSync();
        this.onResize = () => {
          this.bindSwiperEvents();
          this.scheduleSlideSync();
        };
        // The arrow row is shown/hidden by Swiper breakpoints after window resize
        // fires, so watch the row itself to know where the rotation toggle belongs.
        this.arrowsObserver = window.ResizeObserver ? new ResizeObserver(() => this.placeRotationButton()) : null;
        this.swiperObserver = new MutationObserver(() => {
          if (this.bindSwiperEvents()) this.scheduleSlideSync();
        });
        this.showSlide(0);
      }
      if ((_this$motionQuery2 = this.motionQuery) !== null && _this$motionQuery2 !== void 0 && _this$motionQuery2.matches) this.userPaused = true;
      this.placeRotationButton();
      const arrows = this.querySelector(".content-text .slider-controls");
      if (arrows && this.rotationButton) (_this$arrowsObserver = this.arrowsObserver) === null || _this$arrowsObserver === void 0 || _this$arrowsObserver.observe(arrows);
      this.updateRotationLabel();
      this.addEventListener("click", this.onClick);
      this.addEventListener("click", this.onClickCapture, true);
      this.addEventListener("pointerdown", this.onPointerDown);
      this.addEventListener("pointercancel", this.onPointerCancel);
      this.addEventListener("focusin", this.onFocus);
      this.addEventListener("pointerenter", this.onEnter);
      this.addEventListener("pointerleave", this.onLeave);
      document.addEventListener("visibilitychange", this.onVisibility);
      window.addEventListener("resize", this.onResize);
      (_this$motionQuery3 = this.motionQuery) === null || _this$motionQuery3 === void 0 || _this$motionQuery3.addEventListener("change", this.onMotion);
      for (const wrapper of [this.slideImage, this.slideContent]) {
        if (wrapper) this.swiperObserver.observe(wrapper, {
          attributes: true,
          attributeFilter: ["class"]
        });
      }
      // The wrapper adds slide-initialized after its real Swiper instance exists.
      if (this.bindSwiperEvents()) this.scheduleSlideSync();
      this.updateTimer();
    }
    disconnectedCallback() {
      var _this$swiperObserver, _this$arrowsObserver2, _this$sliderBindings2, _this$motionQuery4;
      this.connected = false;
      this.hoverPaused = false;
      this.rotationPointerIntent = null;
      this.arrowFocusIntent = null;
      clearInterval(this.playInterval);
      this.playInterval = null;
      cancelAnimationFrame(this.controlFrame);
      cancelAnimationFrame(this.resizeFrame);
      (_this$swiperObserver = this.swiperObserver) === null || _this$swiperObserver === void 0 || _this$swiperObserver.disconnect();
      (_this$arrowsObserver2 = this.arrowsObserver) === null || _this$arrowsObserver2 === void 0 || _this$arrowsObserver2.disconnect();
      for (const slider of ((_this$sliderBindings = this.sliderBindings) === null || _this$sliderBindings === void 0 ? void 0 : _this$sliderBindings.values()) || []) {
        var _this$sliderBindings;
        for (const event of ["resize", "breakpoint", "init"]) {
          var _slider$off;
          (_slider$off = slider.off) === null || _slider$off === void 0 || _slider$off.call(slider, event, this.onSwiperLayout);
        }
      }
      (_this$sliderBindings2 = this.sliderBindings) === null || _this$sliderBindings2 === void 0 || _this$sliderBindings2.clear();
      this.removeEventListener("click", this.onClick);
      this.removeEventListener("click", this.onClickCapture, true);
      this.removeEventListener("pointerdown", this.onPointerDown);
      this.removeEventListener("pointercancel", this.onPointerCancel);
      this.removeEventListener("focusin", this.onFocus);
      this.removeEventListener("pointerenter", this.onEnter);
      this.removeEventListener("pointerleave", this.onLeave);
      document.removeEventListener("visibilitychange", this.onVisibility);
      window.removeEventListener("resize", this.onResize);
      (_this$motionQuery4 = this.motionQuery) === null || _this$motionQuery4 === void 0 || _this$motionQuery4.removeEventListener("change", this.onMotion);
    }
    bindSwiperEvents() {
      let changed = false;
      for (const wrapper of [this.slideImage, this.slideContent]) {
        var _wrapper$getSlide;
        const slider = wrapper === null || wrapper === void 0 || (_wrapper$getSlide = wrapper.getSlide) === null || _wrapper$getSlide === void 0 ? void 0 : _wrapper$getSlide.call(wrapper);
        const previous = this.sliderBindings.get(wrapper);
        if (previous === slider) continue;
        if (previous) for (const event of ["resize", "breakpoint", "init"]) {
          var _previous$off;
          (_previous$off = previous.off) === null || _previous$off === void 0 || _previous$off.call(previous, event, this.onSwiperLayout);
        }
        this.sliderBindings.delete(wrapper);
        if (slider !== null && slider !== void 0 && slider.on && !slider.destroyed) {
          for (const event of ["resize", "breakpoint", "init"]) slider.on(event, this.onSwiperLayout);
          this.sliderBindings.set(wrapper, slider);
          changed = true;
        }
      }
      return changed;
    }
    scheduleSlideSync() {
      if (!this.connected) return;
      cancelAnimationFrame(this.resizeFrame);
      this.resizeFrame = requestAnimationFrame(() => {
        this.resizeFrame = requestAnimationFrame(() => {
          this.resizeFrame = null;
          if (!this.connected || !this.isConnected) return;
          // Swiper can reset activeIndex after announcing a breakpoint. Reapply
          // the selected item after layout settles without restarting progress.
          for (const wrapper of [this.slideImage, this.slideContent]) {
            var _wrapper$getSlide2, _wrapper$goTo;
            const slider = wrapper === null || wrapper === void 0 || (_wrapper$getSlide2 = wrapper.getSlide) === null || _wrapper$getSlide2 === void 0 ? void 0 : _wrapper$getSlide2.call(wrapper);
            if (slider && !slider.destroyed && slider.activeIndex !== this.indexActive) (_wrapper$goTo = wrapper.goTo) === null || _wrapper$goTo === void 0 || _wrapper$goTo.call(wrapper, this.indexActive);
          }
          this.paintSelection();
          this.paintProgress();
        });
      });
    }
    makeControls() {
      var _this$slideContent;
      if (this.listBlock.length < 2) return;
      const id = `image-carousel-${++instanceCount}`;
      const images = Array.from(this.querySelectorAll(".content-image .block__item"));
      this.listBlock.forEach((item, index) => {
        var _item$querySelector;
        const text = item.querySelector(".block-title span:not(.icon)");
        if (!text) return;
        const button = document.createElement("button");
        button.type = "button";
        button.className = "image-slide-select";
        button.textContent = text.textContent;
        button.setAttribute("aria-pressed", String(index === 0));
        if (images[index]) {
          var _images$index;
          (_images$index = images[index]).id || (_images$index.id = `${id}-image-${index}`);
          button.setAttribute("aria-controls", images[index].id);
        }
        text.replaceWith(button);
        (_item$querySelector = item.querySelector(".line")) === null || _item$querySelector === void 0 || _item$querySelector.setAttribute("aria-hidden", "true");
      });
      this.rotationButton = document.createElement("button");
      this.rotationButton.type = "button";
      this.rotationButton.className = "image-rotation-toggle";
      // Desktop has no arrow row, so the toggle gets its own row below the slide list.
      this.rotationRow = document.createElement("div");
      this.rotationRow.className = "image-rotation-row";
      (((_this$slideContent = this.slideContent) === null || _this$slideContent === void 0 ? void 0 : _this$slideContent.parentElement) || this).append(this.rotationRow);
      this.placeRotationButton();
      this.updateRotationLabel();
    }
    placeRotationButton() {
      if (!this.rotationButton) return;
      // Sit beside the prev/next arrows while they are shown (mobile); otherwise
      // use the row below the slide list so the control is never hidden.
      const arrows = this.querySelector(".content-text .slider-controls");
      const arrowsShown = arrows && arrows.getClientRects().length > 0;
      const target = arrowsShown ? arrows : this.rotationRow;
      if (this.rotationButton.parentElement === target) return;
      const hadFocus = document.activeElement === this.rotationButton;
      target.append(this.rotationButton);
      this.rotationRow.hidden = arrowsShown;
      if (hadFocus) this.rotationButton.focus({
        preventScroll: true
      });
    }
    updateRotationLabel() {
      if (!this.rotationButton) return;
      const strings = window.espAccessibilityStrings || {};
      const label = this.userPaused ? strings.imageRotationResume || "Resume rotation" : strings.imageRotationPause || "Pause rotation";
      this.rotationButton.innerHTML = this.userPaused ? PLAY_ICON : PAUSE_ICON;
      this.rotationButton.setAttribute("aria-label", label);
      this.rotationButton.title = label;
    }
    pause() {
      this.userPaused = true;
      this.updateRotationLabel();
      this.updateTimer();
    }
    handleClick(event) {
      if (event.target.closest(".image-rotation-toggle") === this.rotationButton) {
        // Pointer focus may already have paused rotation. Honor the action seen
        // at pointerdown; keyboard clicks use the current action after focus.
        this.userPaused = event.detail > 0 && this.rotationPointerIntent != null ? this.rotationPointerIntent : !this.userPaused;
        this.rotationPointerIntent = null;
        this.updateRotationLabel();
        this.updateTimer();
        return;
      }
      this.rotationPointerIntent = null;
      const control = event.target.closest(".content-text .slider-controls button");
      if (control && this.contains(control)) {
        const restoreFocus = this.arrowFocusIntent === control;
        this.arrowFocusIntent = null;
        this.pause();
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = null;
        cancelAnimationFrame(this.controlFrame);
        this.controlFrame = requestAnimationFrame(() => {
          var _this$slideContent$ge, _this$slideContent2, _this$slideContent2$g;
          if (!this.isConnected) return;
          this.showSlide((_this$slideContent$ge = (_this$slideContent2 = this.slideContent) === null || _this$slideContent2 === void 0 || (_this$slideContent2$g = _this$slideContent2.getSlide) === null || _this$slideContent2$g === void 0 || (_this$slideContent2$g = _this$slideContent2$g.call(_this$slideContent2)) === null || _this$slideContent2$g === void 0 ? void 0 : _this$slideContent2$g.activeIndex) !== null && _this$slideContent$ge !== void 0 ? _this$slideContent$ge : this.indexActive);
          if (restoreFocus) this.restoreArrowFocus(control);
        });
        return;
      }
      // Descriptive links retain their normal navigation and are not slide selectors.
      if (event.target.closest("a[href]")) return;
      const index = this.listBlock.indexOf(event.target.closest(".block__item"));
      if (index >= 0) {
        this.pause();
        this.showSlide(index);
      }
    }
    restoreArrowFocus(control) {
      var _ref;
      if (!control.disabled && control.tabIndex >= 0 && control.getAttribute("aria-disabled") !== "true") return;
      if (document.activeElement !== document.body && document.activeElement !== control) return;
      // Preserve Swiper's disabled endpoint, but retain a useful editing position
      // when that specific user activation caused the focused button to disable.
      const other = Array.from(this.slideContent.querySelectorAll(".slider-controls button:not(.image-rotation-toggle)")).find(button => button !== control && !button.disabled && button.tabIndex >= 0 && button.getAttribute("aria-disabled") !== "true");
      (_ref = other || this.rotationButton || this.querySelector('.image-slide-select[aria-pressed="true"]')) === null || _ref === void 0 || _ref.focus({
        preventScroll: true
      });
    }
    showSlide(index) {
      var _this$slideImage, _this$slideImage$goTo, _this$slideContent3, _this$slideContent3$g;
      if (!this.listBlock.length || !Number.isFinite(Number(index))) return;
      this.indexActive = (Number(index) + this.listBlock.length) % this.listBlock.length;
      this.elapsed = 0;
      this.lastTick = performance.now();
      (_this$slideImage = this.slideImage) === null || _this$slideImage === void 0 || (_this$slideImage$goTo = _this$slideImage.goTo) === null || _this$slideImage$goTo === void 0 || _this$slideImage$goTo.call(_this$slideImage, this.indexActive);
      (_this$slideContent3 = this.slideContent) === null || _this$slideContent3 === void 0 || (_this$slideContent3$g = _this$slideContent3.goTo) === null || _this$slideContent3$g === void 0 || _this$slideContent3$g.call(_this$slideContent3, this.indexActive);
      this.paintSelection();
      this.paintProgress();
    }
    paintSelection() {
      this.listBlock.forEach((item, index) => {
        var _item$querySelector2;
        item.classList.toggle("swiper-slide-active", index === this.indexActive);
        (_item$querySelector2 = item.querySelector(".image-slide-select")) === null || _item$querySelector2 === void 0 || _item$querySelector2.setAttribute("aria-pressed", String(index === this.indexActive));
      });
    }
    paintProgress() {
      this.listBlock.forEach((item, index) => {
        const bar = item.querySelector(".line");
        if (bar) bar.style.width = `${index === this.indexActive ? Math.min(100, this.elapsed / this.duration * 100) : 0}%`;
      });
    }
    updateTimer() {
      const running = this.connected && this.isConnected && this.listBlock.length > 1 && !this.userPaused && !this.hoverPaused && !document.hidden;
      if (!running) {
        if (this.playInterval !== null) {
          this.elapsed += Math.max(0, performance.now() - this.lastTick);
          this.paintProgress();
          clearInterval(this.playInterval);
          this.playInterval = null;
        }
        return;
      }
      if (this.playInterval !== null) return;
      this.lastTick = performance.now();
      // One owned timer advances both the progress indicator and the slide.
      this.playInterval = setInterval(() => {
        const now = performance.now();
        this.elapsed += Math.max(0, now - this.lastTick);
        this.lastTick = now;
        if (this.elapsed >= this.duration) this.showSlide(this.indexActive + 1);else this.paintProgress();
      }, 50);
    }
  });
})();
